import React from "react";
import {
  Grid,
  Typography,
  TextField,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import QuestionFilters from "./QuestionFilters";

const Filters = ({ questions, search }) => {
  const [filters, setFilters] = React.useState({
    user: {},
    profile: {},
    answer: {},
  });

  const handleChange = (obj, field, value) => {
    let f = filters;
    f[obj][field] = value;
    setFilters({ ...f });
  };

  const clearFilters = () => {
    setFilters({
      user: {},
      profile: {},
      answer: {},
    });
  };

  const handleQuestionFilterUpdate = (action, questionId, answer) => {
    let f = filters;
    if (action === "add") {
      f.answer[questionId] = answer;
    } else if (action === "clear") {
      delete f.answer[questionId];
    }
    setFilters({ ...f });
  };

  const disableSave = () => {

    if (Object.keys(filters.user).length === 0 && Object.keys(filters.profile).length === 0 && Object.keys(filters.answer).length === 0 ) {
      return true
    }
    return false
  }

 

  return (
    <Grid container spacing={3}>
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h6" style={{ paddingLeft: 10 }}>
          Search Criteria
        </Typography>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Button
            variant="outlined"
            size="small"
            style={{ marginRight: 20 }}
            onClick={clearFilters}
          >
            clear
          </Button>
          <Button
            variant="contained"
            size="small"
            style={{ paddingRight: 10 }}
            onClick={() => search(filters)}
            disabled={disableSave() ? true : false}
          >
            search
          </Button>
        </div>
      </Grid>
      <Grid item xs={12}>
        <Grid container direction="row" spacing={3}>
          <Grid item md={4} xs={6}>
            <TextField
              size="small"
              fullWidth
              label="First Name"
              value={
                filters?.profile?.firstName ? filters.profile.firstName : ""
              }
              onChange={(e) =>
                handleChange("profile", "firstName", e.target.value)
              }
            />
          </Grid>
          <Grid item md={4} xs={6}>
            <TextField
              size="small"
              fullWidth
              label="Last Name"
              value={filters?.profile?.lastName ? filters.profile.lastName : ""}
              onChange={(e) =>
                handleChange("profile", "lastName", e.target.value)
              }
            />
          </Grid>
          <Grid item md={4} xs={6}>
            <TextField
              size="small"
              fullWidth
              label="Email"
              value={filters?.user?.email ? filters.user.email : ""}
              onChange={(e) => handleChange("user", "email", e.target.value)}
            />
          </Grid>
          <Grid item md={4} xs={6}>
            <FormControl size="small" fullWidth>
              <Select
                value={
                  filters?.profile?.ageRange ? filters.profile.ageRange : ""
                }
                onChange={(e) =>
                  handleChange("profile", "ageRange", e.target.value)
                }
              >
                <MenuItem value={"21-25"}>21-25</MenuItem>
                <MenuItem value={"26-30"}>26-30</MenuItem>
                <MenuItem value={"31-35"}>31-35</MenuItem>
                <MenuItem value={"36-40"}>36-40</MenuItem>
                <MenuItem value={"41-45"}>41-45</MenuItem>
                <MenuItem value={"46-50"}>46-50</MenuItem>
              </Select>
              <FormHelperText>Age Range</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item md={4} xs={6}>
            <FormControl size="small" fullWidth>
              <Select
                value={
                  filters?.profile?.pronouns ? filters.profile.pronouns : ""
                }
                onChange={(e) =>
                  handleChange("profile", "pronouns", e.target.value)
                }
              >
                <MenuItem value={"He/Him"}>He/Him</MenuItem>
                <MenuItem value={"She/Her"}>She/Her</MenuItem>
                <MenuItem value={"They/Them"}>They/Them</MenuItem>
                <MenuItem value={"Other"}>Other</MenuItem>
              </Select>
              <FormHelperText>Pronouns</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item md={4} xs={6}>
            <FormControl size="small" fullWidth>
              <Select
                value={
                  filters?.user?.matchmakingTier
                    ? filters.user.matchmakingTier
                    : ""
                }
                onChange={(e) =>
                  handleChange("user", "matchmakingTier", e.target.value)
                }
              >
                <MenuItem value={0}>None</MenuItem>
                <MenuItem value={1}>Free</MenuItem>
                <MenuItem value={2}>Silver</MenuItem>
                <MenuItem value={3}>Gold</MenuItem>
              </Select>
              <FormHelperText>Matchmaking Tier</FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body1">Questions Filters</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <QuestionFilters
              questions={questions}
              update={handleQuestionFilterUpdate}
            />
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  );
};

export default Filters;
